export default "__VITE_ASSET__D8fvTd8X__"